import React, { useContext} from 'react';
import { Rail, Segment, Tab } from 'semantic-ui-react';
import MobileStore from '../../../app/stores/mobileStore';
import MobileArtifactsTab from './MobileArtifactsTab';
import MobileAssignmentTab from './MobileAssignmentTab';
import MobileBogTab from './MobileBogTab';
import MobileLogTab from './MobileLogTab';
import MobileMaterialTab from './MobileMaterialTab';
import MobilePermitTab from './MobilePermitTab';
import MobilePOTab from './MobilePOTab';
import MobileScopeTab from './MobileScopeTab';
import MobileVariationTab from './MobileVariationTab';
import MobileVendorTab from './MobileVendorTab';

const MobileTab = () => {
  const mobileStore = useContext(MobileStore);
  const { activeDetailTab, setActiveDetailTab} = mobileStore;
const panes = [
   { menuItem: 'Scope', render: () => <MobileScopeTab/>  },
   { menuItem: 'Assignment', render: () => <MobileAssignmentTab/> },
   { menuItem: 'PO', render: () => <MobilePOTab/> },
   { menuItem: 'Access', render: () => <MobilePermitTab/> },
   { menuItem: 'BOG', render: () => <MobileBogTab/> },
   { menuItem: 'Material', render: () => <MobileMaterialTab/> },
   { menuItem: 'Third Party', render: () => <MobileVendorTab/> },
   { menuItem: 'Variation', render: () => <MobileVariationTab/> },
   { menuItem: 'Artifacts', render: () => <MobileArtifactsTab/> },
   { menuItem: 'Log', render: () => <MobileLogTab />  }
];

  return (
    <Tab
      panes={panes}
      onTabChange={(e, data) => setActiveDetailTab(Number(data.activeIndex))}
      defaultActiveIndex={activeDetailTab}
    />
  );
};

export default MobileTab;
